import type { BadgeItem } from "@risalabs_frontend_org/oasis-ui-kit";
import { BadgeGroup } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import EditIcon from "../../../../svg/editIcon";

interface BadgeGroupWithEditIconCellProps {
  value: {
    badges: BadgeItem[];
    maxVisible?: number;
    size?: "small" | "medium" | "large";
  };
  handleEditIconClick?: (data: any) => void;
  rowData?: any;
  [key: string]: any;
}

export const BadgeGroupWithEditIconCell: React.FC<
  BadgeGroupWithEditIconCellProps
> = ({ value, handleEditIconClick, rowData }) => {
  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleEditIconClick?.(rowData ?? value);
  };

  return (
    <div className="table-cell-badge-group-with-edit flex min-w-0 max-w-full flex-row items-center gap-2 overflow-hidden">
      <div className="min-w-0 max-w-full flex-1 overflow-hidden">
        <BadgeGroup
          badges={value?.badges ?? []}
          maxVisible={value?.maxVisible}
          size={value?.size ?? "small"}
        />
      </div>
      <div
        onClick={handleEditClick}
        className="flex flex-shrink-0 cursor-pointer items-center justify-center rounded p-0.5"
        aria-label="Edit"
      >
        <EditIcon width="14" height="14" strokeColor="#0056D6" />
      </div>
    </div>
  );
};

export default BadgeGroupWithEditIconCell;
